import { CustomerInputType } from '@hello-pimster/pimster-crm-sdk';

export const COOKIE_ID_HEADER = 'X-Cookie-Id';
export const LOCALE_HEADER = 'X-Locale';
export const CHAT_CONTROLLER_COMPLETION_PATH = (chatId: string) =>
    `v1/chat/${chatId}/completion`;
export const CUSTOMER_INPUT_CONTROLLER_ATTACHMENT_PATH =
    'v1/customer-input/attachment';
export const CUSTOMER_INPUT_TYPES: string[] = Object.values(CustomerInputType);
